export default "__VITE_ASSET__BA016Exj__"